// extracted by mini-css-extract-plugin
module.exports = {"groupsList":"_1TMzCFNu-mPqJeJsRndrH2"};